import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailsWokingDayAPIService {

  constructor(private http: HttpClient) { }
  public async getDataGrid(filter: string, page = 0, size = 10): Promise<any> {
    if (page > 0)
      page = page - 1; // Adjusting page for zero-based index
    const url = `/assistance/report/roll?filter=${filter}&page=${page}&size=${size}&sort=e.creation_date::desc`;
    console.log('url Reporte', url);
    const response = await this.http.get(url).toPromise();
    return response;
  }


  public getReportFile(filter: string, page = 0, size = 10): Observable<any> {
    if (page > 0)
      page = page - 1; // Adjusting page for zero-based index
    const url = `/assistance/report/xls/person?filter=${filter}&page=${page}&size=${size}&sort=e.creation_date::desc`;
    console.log('url Reporte', url);
    return this.http.get<any>(url, { observe: 'response' });
  }

}
